import IPermissionService from 'services/permission/IPermissionService';
import { ORDER_HIDEABLE_TABS } from 'typings/models/order/order.enum';
import { USER_ROLE } from 'typings/models/user.enum';
import { TENANT_TYPE } from 'typings/subEntities/tenant.enum';

export default class EnterpriseUtils {
  public static getPermissionConfigs = (enterprise: Enterprise, currentUser: User): IPermissionService.PermissionConfigs => {
    const { fieldVisibilitySettings, fieldUpdateSettings, tabsVisibilitySettings } = enterprise.settings.order;
    return {
      canCreateCustomServices:
        currentUser.roles.includes(USER_ROLE.orderManager) &&
        [TENANT_TYPE.enterprise, TENANT_TYPE.platformOperator].includes(currentUser.type)
          ? enterprise.clientPricelistSettings.allowAddCustomServices
          : enterprise.technicianPricelistSettings.allowAddCustomServices,
      geoPointForServerActions:
        currentUser.roles.includes(USER_ROLE.orderTechnician) &&
        [TENANT_TYPE.enterprise, TENANT_TYPE.platformOperator].includes(currentUser.type)
          ? enterprise.settings.technician.geoPositionTrackingType
          : undefined,
      orderFieldVisitbility: fieldVisibilitySettings.configMap[currentUser.position.technicalName],
      orderFieldUpdateConfig: fieldUpdateSettings?.configMap[currentUser.position.technicalName],
      orderTabsVisibilityConfig: tabsVisibilitySettings
        ? {
            hiddenTabs: new Set(
              tabsVisibilitySettings.configMap[currentUser.position.technicalName]?.hiddenTabs
            ) as Set<ORDER_HIDEABLE_TABS>,
          }
        : { hiddenTabs: new Set() as Set<ORDER_HIDEABLE_TABS> },
    };
  };

  public static isEntityInherited = (currentUser: User | null, entity: EntityWithTenant): boolean => {
    return currentUser?.tenant.id !== entity.tenant.id;
  };

  public static getEntityOwnerName = (currentUser: User | null, entity: EntityWithTenant): string => {
    const isInherited = this.isEntityInherited(currentUser, entity);
    return isInherited ? entity.tenant.name : '';
  };
}
